<template>
	<form class="form" @submit.prevent="submit" novalidate>
		<ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>

		<fieldset class="form__group">
			<legend>Company Details</legend>

			<div class="form__group">
				<input
                    id="name"
                    class="form__control"
                    v-model="formData.name"
                    v-validate
                    required
                    name="companyName"
                    placeholder="Enter the name of the company here..."
                />
				<label for="name" class="form__label">Name of company</label>
				<div class="form__validation">{{ errors.first('companyName') }}</div>
			</div>

			<FileUpload
                id="logo"
                label="Company logo"
                name="logo"
                v-model="formData.logo.uuid"
                v-validate="'required'"
            />

			<div class="form__group">
				<input
                    id="name"
                    class="form__control"
                    v-model="formData.website"
                    v-validate
                    required
                    name="website"
                    placeholder="Enter the company website here..."
                />
				<label for="name" class="form__label">Company Website</label>
				<div class="form__validation">{{ errors.first('website') }}</div>
			</div>


			<FormControlRegion
                label="Region covered"
                name="region"
                v-model="formData.region"
                v-validate="'required'"
            />

			<FormControlCountry
                label="Company HQ country"
                name="hqCountry"
                v-model="formData.hqCountry"
                v-validate="'required'"
            />
			<div class="form__group">
				<input
                    id="hq-location"
                    class="form__control"
                    name="hqLocation"
                    v-model="formData.hqLocation"
                    placeholder="Enter a location..."
                    v-validate
                    required
                />
				<label for="hq-location" class="form__label">Company HQ location</label>
				<div class="form__validation">{{ errors.first('hqLocation') }}</div>
			</div>

            <div class="form__group">
                <input :id="`hq-address-line-1`" class="form__control" name="hq_address_line_1"
                       v-model="formData.hqAddressLine1" placeholder="Enter Address Line 1..." v-validate />
                <label :for="`hq-address-line-1`" class="form__label">Address Line 1</label>
            </div>
            <div class="form__group">
                <input :id="`hq-address-line-2`" class="form__control" name="hq_address_line_2"
                       v-model="formData.hqAddressLine2" placeholder="Enter Address Line 2..." v-validate />
                <label :for="`hq-address-line-2`" class="form__label">Address Line 2</label>
            </div>
            <div class="form__group">
                <input :id="`hq-address-line-3`" class="form__control" name="hq_address_line_3"
                       v-model="formData.hqAddressLine3" placeholder="Enter Address Line 3..." v-validate />
                <label :for="`hq-address-line-3`" class="form__label">Address Line 3</label>
            </div>
            <div class="form__group">
                <input :id="`hq-telephone`" class="form__control" name="hq_telephone"
                       v-model="formData.hqPhone" placeholder="Enter Telephone Number..." v-validate />
                <label :for="`hq-telephone`" class="form__label">Telephone Number</label>
            </div>

			<template v-for="(office, index) in offices">
				<hr />

				<input type="hidden" v-model="office.id" />

                <button class="action" @click.prevent="showDeleteModal(office.uuid)">
                    <svg class="svg-icon">
                        <use xlink:href="#icon--delete" style="fill: #FF0000; stroke: none;"></use>
                    </svg>
                </button>

				<FormControlCountry :id="`office-${index}-country`" label="Office country*" name="officeCountry"
				                    v-model="office.country" v-validate="'required'">
				</FormControlCountry>

				<div class="form__group">

					<input :id="`office-${index}-location`" class="form__control" name="officeLocation"
					       v-model="office.location" placeholder="Enter a location..."  v-validate
					       required />
					<label :for="`office-${index}-location`" class="form__label">Office location*</label>
					<div class="form__validation">{{ errors.first('officeLocation') }}</div>
				</div>
                <div class="form__group">
                    <input :id="`office-${index}-address-line-1`" class="form__control" name="address_line_1"
                           v-model="office.address_line_1" placeholder="Enter Address Line 1..."  v-validate />
                    <label :for="`office-${index}-address-line-1`" class="form__label">Address Line 1</label>
                </div>
                <div class="form__group">
                    <input :id="`office-${index}-address-line-2`" class="form__control" name="address_line_2"
                           v-model="office.address_line_2" placeholder="Enter Address Line 2..."  v-validate />
                    <label :for="`office-${index}-address-line-2`" class="form__label">Address Line 2</label>
                </div>
                <div class="form__group">
                    <input :id="`office-${index}-address-line-3`" class="form__control" name="address_line_3"
                           v-model="office.address_line_3" placeholder="Enter Address Line 3..."  v-validate />
                    <label :for="`office-${index}-address-line-3`" class="form__label">Address Line 3</label>
                </div>
                <div class="form__group">
                    <input :id="`office-${index}-telephone`" class="form__control" name="telephone"
                           v-model="office.phone" placeholder="Enter Telephone Number..."  v-validate />
                    <label :for="`office-${index}-telephone`" class="form__label">Telephone Number</label>
                </div>
            </template>

			<div class="form__group">
				<button class="btn btn--link" @click.prevent="addOffice">Add additional office</button>
			</div>

			<div v-if="type === 'create'" class="form__group form__group--submit">
				<router-link :to="{ name: 'members' }" class="btn">Back</router-link>
				<button class="btn btn--primary" v-wait:disabled='["submit", "logo uploading"]'>Save &amp; Continue</button>
			</div>
            <div v-else class="form__group form__group--submit">
                <router-link :to="`/members/${id}`" class="btn">Back</router-link>
                <button class="btn btn--primary" v-wait:disabled='["submit", "logo uploading"]'>Update Member</button>
            </div>
		</fieldset>
        <v-dialog />
	</form>
</template>

<script>
	import MemberFormStep from './MemberFormStep';
	import FormControlCountry from '../../Form/Control/FormControlCountry';
	import FormControlRegion from '../../Form/Control/FormControlRegion';
	import FileUpload from '../../Form/FileUpload';
	import ValidationAlert from '../../ValidationAlert';
    import {v4 as uuidv4} from 'uuid';

    export default {
		name: 'MemberFormStep1',
		components: {
			ValidationAlert,
			FileUpload,
			FormControlRegion,
			FormControlCountry
		},
		mixins: [MemberFormStep],
        props: {
            logo: {
                type: String,
                default: null,
            },
            type: {
                type: String,
                default: 'create',
            }
        },
		data() {
			return {
				formData: {
					name: null,
					logo: {
                        uuid: null,
                        url: null,
                        filename: null,
                    },
                    website: null,
                    logoUrl: null,
					region: null,
                    hqUuid: uuidv4(),
					hqCountry: null,
					hqLocation: null,
                    hqAddressLine1: null,
                    hqAddressLine2: null,
                    hqAddressLine3: null,
                    hqPhone: null,
					offices: [],
				},
                shouldEditLogo: false,
			}
		},
        computed: {
            // offices without the hq
            offices() {
                return this.formData.offices;
            }
        },
		methods: {
			addOffice() {
				this.formData.offices.push({
					country: null,
					location: '',
                    address_line_1: '',
                    address_line_2: '',
                    address_line_3: '',
                    phone: '',
                    uuid: uuidv4(),
				});
			},
            showDeleteModal(officeUuid){
                console.log('showDeleteModal');
                this.$modal.show('dialog', {
                    title:'Are you sure?',
                    text: 'Clicking delete will remove this office. ' +
                        ' Users assigned to this office will be re-assigned to the member HQ.',
                    buttons: [
                        {
                            class: 'btn btn--danger',
                            title: 'DELETE',
                            handler: () => {
                                this.formData.offices = this.formData.offices.filter(office => office && office.uuid !== officeUuid);
                                this.$modal.hide('dialog');
                            }
                        },
                    ]
                });
            },
		}
	}
</script>

<style lang="scss" scoped>
    .action {
        appearance: none;
        background-color: transparent;
        border: none;
        outline: none !important;
        cursor: pointer;
        height: 2.5rem;
        width: 2.5rem;
        padding: 0;
        margin-bottom: 1.5rem;
        margin-left: auto;

        .svg-icon{
            height: 2.5rem;
            width: 2.5rem;
            fill: #E42034;
            stroke: transparent;
            margin-right: 0;
        }
    }
</style>
